import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
import pure from 'utils/pure';
import s from 'components/shared/cookiesModal/cookiesModal.sss';

export default @pure class Modal extends Component {

	constructor(props) {
		super(props);
		this.acceptCookies = this.sendResult.bind(this, true);
		this.rejectCookies = this.sendResult.bind(this, false);
	}

	sendResult(value) {
		Store.emit(actions.HIDE_MODAL, value === true);
	}

	render(props) {
		let appData = props.appData || Store.get().appData || {};
		let copy = appData.copy || {};
		return (
			<div class={s.container}>
				<h3 class={s.title}>{copy.$COOKIES_MODAL_TITLE}</h3>
				<div class={s.text}>{copy.$COOKIES_MODAL_TEXT}</div>
				<div class={s.buttons}>
					<button class={s.yes} type="button" onClick={this.acceptCookies}>
						{copy.$COOKIES_MODAL_ACCEPT}
					</button>
					<button class={s.no} type="button" onClick={this.rejectCookies}>
						{copy.$COOKIES_MODAL_DENY}
					</button>
				</div>
			</div>
		);
	}

}
